import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

const ButtonLinkHref = ({
                            to,
                            className = '',
                            children,
                            openInNewTab = false,
                        }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = (e) => {
        if (loading) {
            e.preventDefault();
            return;
        }

        setLoading(true);
        // simulate navigation delay (optional)
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };

    return (
        <a
            href={to}
            target={openInNewTab ? '_blank' : '_self'}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            style={{ textDecoration: 'none' }}
            onClick={handleClick}
        >
            <LoadingButton
                onClick={handleClick}
                loading={loading}
                variant="contained"
                sx={{
                    paddingX: 2,
                    paddingY: 1,
                    backgroundColor: '#4d4d4d', // Black
                    '&:hover': {
                        backgroundColor: '#3d3d3d', // Slightly lighter black for hover
                    },
                    borderTop: '2px solid #2d2d2d',
                    borderRight: '2px solid #2d2d2d',
                    borderLeft: '2px solid #2d2d2d',
                    borderBottom: '8px solid #2d2d2d',
                    '&:active': {
                        borderBottom: '4px solid #2d2d2d',
                    },
                    color: '#ffffff',
                    fontSize: 16,
                    textTransform: 'none',
                    borderRadius: '12px',
                }}
                className={className}
            >
                {children}
            </LoadingButton>
        </a>
    );
};

export default ButtonLinkHref;
